import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "clearButton", "signatureData", "typedSignature", "canvasWrapper", "typedWrapper", "toggleCanvas", "toggleTyped"]

  connect() {
    this.initializeCanvas()
    this.showCanvasMode()
  }

  initializeCanvas() {
    const canvas = this.canvasTarget
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext("2d").scale(ratio, ratio)

    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(0, 0, 0)'
    })

    this.signaturePad.addEventListener("endStroke", () => {
      this.updateSignatureData()
    })
  }

  updateSignatureData() {
    if (!this.signaturePad.isEmpty()) {
      const dataURL = this.signaturePad.toDataURL()
      this.convertDataURLToBlob(dataURL)
    }
  }

  convertDataURLToBlob(dataURL) {
    fetch(dataURL)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], "signature.png", { type: "image/png" })
        const dataTransfer = new DataTransfer()
        dataTransfer.items.add(file)

        if (this.hasSignatureDataTarget) {
          this.signatureDataTarget.files = dataTransfer.files
          // Programmatic .files assignment doesn't fire change — dispatch
          // manually so listeners (e.g. waiver-submit-gate) can react.
          this.signatureDataTarget.dispatchEvent(new Event("change", { bubbles: true }))
        }
      })
  }

  clear() {
    this.signaturePad.clear()
    if (this.hasSignatureDataTarget) {
      this.signatureDataTarget.value = ""
      this.signatureDataTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  showCanvasMode() {
    if (this.hasCanvasWrapperTarget && this.hasTypedWrapperTarget) {
      this.canvasWrapperTarget.classList.remove('hidden')
      this.typedWrapperTarget.classList.add('hidden')
      
      if (this.hasToggleCanvasTarget && this.hasToggleTypedTarget) {
        this.toggleCanvasTarget.classList.add('active')
        this.toggleTypedTarget.classList.remove('active')
      }
      
      // Clear typed signature when switching to canvas
      if (this.hasTypedSignatureTarget) {
        this.typedSignatureTarget.value = ""
      }
    }
  }

  showTypedMode() {
    if (this.hasCanvasWrapperTarget && this.hasTypedWrapperTarget) {
      this.canvasWrapperTarget.classList.add('hidden')
      this.typedWrapperTarget.classList.remove('hidden')
      
      if (this.hasToggleCanvasTarget && this.hasToggleTypedTarget) {
        this.toggleCanvasTarget.classList.remove('active')
        this.toggleTypedTarget.classList.add('active')
      }
      
      // Clear canvas signature when switching to typed
      this.clear()
    }
  }

  disconnect() {
    if (this.signaturePad) {
      this.signaturePad.off()
    }
  }
}
